<template>
  <vNav v-if="screen_type == 'pc'"></vNav>
  <vNav_mobile v-else></vNav_mobile>
  <span class="vbody">
    <img src="/v_image/img52.jpg" alt="" width="100%" height="120px">
    <div class="pub">
      <vPublication :msg="Get_Name_List()"></vPublication>
    </div>
    
  </span>
  
  
</template>

<script>


import vNav from './components/vNav.vue'
import vNav_mobile from './components/vNav_mobile.vue'
import vPublication from './components/vPublication.vue'
export default {
  name: 'App',
  components: {
    vNav,
    vNav_mobile,
    vPublication
  },
  data(){
    return{
      chara_name_list:["Huanqiang Zeng","H. Q. Zeng","Jing Chen","J. Chen","Jianqing Zhu","J. Q. Zhu","Yifan Shi","Y. F. Shi"],
      screen_type:"pc"
      
    }
  },
  methods:{
    Get_Name_List(){
      return {
        chara_name_list:this.chara_name_list
      }
    }
  },
  mounted(){
    setInterval(() => {
      if (window.screen.availWidth < 768) {
        this.screen_type = "phone";
      } else {
        this.screen_type = "pc";
      }
    }, 1000);
  }
}
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
  
}
.vbody{
  text-align: center;
  width: 100vw;
  margin-top: 10px;
}
.pub{
  /* background-color: rebeccapurple; */
  display: inline-block;
  margin-left: 10vw;
}
</style>
